export const getUiCore = async () => import(/* webpackChunkName: "fulluicore" */'@tencent/ui-core');
